import {Component, AfterViewInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {Globals} from '../../../globals';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements AfterViewInit {
  visibility = 'hidden';
  scroll: number;

  //для открытия пунктов меню
  show_main = false;
  show_stat = false;
  show_events = false;
  show_track = false;
  show_anal = false;

  constructor(
    public dialog: MatDialog,
    public translate: TranslateService,
    public Globals: Globals,
    private router: Router
  ) {
    window.onload = () => this.scrolling();
  }

  //показываем или скрываем пункты меню в зависимости от наличия привелегий у юзера
  checkUser(priv: any) {
    let user_privs = this.Globals.user.role.privileges;
    let target_priv: any;
    let priv_exist = true;
    switch (priv) {
      case 'stat':
        target_priv = user_privs.find((priv: {
          privileges_id: string;
        }) => priv.privileges_id == '5e686f03-b975-5dee-01ba-d9f877b8fb5d')
        if (Boolean(target_priv)) {
          priv_exist = true;
        } else {
          priv_exist = false;
        }
        break;
      case 'events':
        target_priv = user_privs.find((priv: {
          privileges_id: string;
        }) => priv.privileges_id == '37d60352-b0bc-b06c-bf89-a066213cfbf1')
        if (Boolean(target_priv)) {
          priv_exist = true;
        } else {
          priv_exist = false;
        }
        break;
      case 'tracking':
        target_priv = user_privs.find((priv: {
          privileges_id: string;
        }) => priv.privileges_id == '1bc0e953-6fff-67e2-4eaa-373851af14af')
        if (Boolean(target_priv)) {
          priv_exist = true;
        } else {
          priv_exist = false;
        }
        break;
      case 'analisis':
        target_priv = user_privs.find((priv: {
          privileges_id: string;
        }) => priv.privileges_id == '6cf6d514-cf90-4ff6-b0f2-cf7f90964497')
        if (Boolean(target_priv)) {
          priv_exist = true;
        } else {
          priv_exist = false;
        }
        break;
    }

    return priv_exist;
  }

  openMenu(item: any) {
    switch (item) {
      case "main":
        this.show_main = true;
        this.show_stat = false;
        this.show_events = false;
        this.show_anal = false;
        break;
      case "stat":
        this.show_stat = true;
        if (this.show_stat && this.show_events) {
          this.show_events = false;
        }
        if (this.show_stat && this.show_anal) {
          this.show_anal = false;
        }
        break;
      case "events":
        this.show_events = true;
        if (this.show_stat && this.show_events) {
          this.show_stat = false;
        }
        if (this.show_events && this.show_anal) {
          this.show_anal = false;
        }
        break;
      case "track":
        this.show_track = true;
        this.show_stat = false;
        this.show_events = false;
        this.show_anal = false;
        break;
      case "anal":
        this.show_anal = true;
        if (this.show_anal && this.show_events) {
          this.show_events = false;
        }
        if (this.show_anal && this.show_stat) {
          this.show_stat = false;
        }
        break;

      case "all":
        this.show_main = false;
        this.show_stat = false;
        this.show_events = false;
        this.show_anal = false;
        break;
    }
  }

  //переход по ссылкам, сделано здесь для работы нового древовидного меню
  //и проверки для показа селекта выбора проектов
  route(link: any) {
    this.toggleVisibility();
    switch (link) {
      case 'det_stat':
        this.router.navigate(['/report/sensor-statistics']);
        break;
      case 'cons_stat':
        this.router.navigate(['/report/consolidated-statistics']);
        break;
      case 'det_events':
        this.router.navigate(['/report/sensor-events']);
        break;
      case 'cons_events':
        this.router.navigate(['/report/consolidated-events']);
        break;
      case 'all_events':
        this.router.navigate(['/report/all-events']);
        break;
      case 'main':
        this.router.navigate(['/main']);
        break;
      case 'tracking':
        this.router.navigate(['/admin/vehicle-tracking']);
        break;
    }
  }

  ngAfterViewInit() {
    if (Boolean(this.Globals.user)) {
      this.scrolling();
    }
  }

  toggleVisibility() {
    this.visibility = this.visibility == 'shown' ? 'hidden' : 'shown';
  }

  scrolling() {
    this.scroll = Number(window.scrollY);
    let Element = (<HTMLScriptElement[]><any>document.getElementsByClassName('menuFixed'))[0];
    let menu = (<HTMLScriptElement[]><any>document.getElementsByTagName('menu'))[0];
    let dialog = (<HTMLScriptElement[]><any>document.getElementsByTagName('mat-dialog-container'))[0];
    if (Boolean(this.Globals)) {
      let menu_margin = 100;
      if (this.Globals.hiddenAdmin) {
        Element.style.top = '50px';
        menu_margin = 50;
      }
      if (!Boolean(dialog) && Boolean(Element)) {
        if (this.scroll < 100) {
          Element.style.top = (100 - this.scroll) + 'px';
        } else if (this.scroll >= menu_margin) {
          Element.style.top = '0';
        } else {
          Element.style.top = '100px';
        }
      }
    }

    window.scroll(window.scrollX, this.scroll);
  }
}
